import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../../context/AuthContext";

export default function FinalCta() {
  const { user } = useAuth();

  return (
    <section data-testid="cta-final-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-28 lg:py-40">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl mx-auto text-center"
        >
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-zinc-950 leading-[1.08]">
            Dale una identidad digital a tu primera máquina.
          </h2>
          <p className="text-lg sm:text-xl text-zinc-600 leading-relaxed mt-6">
            Empieza a organizar tus equipos en minutos.
          </p>
          <div className="mt-10">
            <Link
              to={user ? "/app/machines/new" : "/solicitar-acceso"}
              data-testid="cta-final-submit-button"
              className="inline-flex items-center px-9 py-4 rounded-full bg-zinc-900 text-white text-lg font-medium hover:bg-zinc-800 hover:scale-[1.03] active:scale-95 transition-[background-color,transform] duration-200"
            >
              {user ? "Crear mi primera máquina" : "Probar Asset Passport"}
            </Link>
          </div>
          <p className="text-sm text-zinc-400 mt-6">
            Sin instalaciones complejas. Sin formación. Empieza con una máquina.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
